import { configureStore } from '@reduxjs/toolkit';
import userActionLogsReducer from './slices/userActionLogsSlice';
import loaderReducer from './slices/loader';
import analyticsReducer from './slices/analytics'
export const store = configureStore({
  reducer: {
    userActionLogs: userActionLogsReducer,
    loader: loaderReducer,
    analytics:analyticsReducer
  },
});
